// extracted by mini-css-extract-plugin
module.exports = {"headingSubLabel":"order-card_headingSubLabel__oF84h","rightElement":"order-card_rightElement__O7pC9","topMargin":"order-card_topMargin__E83za"};